import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { authApi } from '@/api/auth';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { notifyError, notifySuccess } from '@/lib/feedback';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [serverMessage, setServerMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError('');
    setServerMessage('');
    setIsSubmitting(true);

    try {
      const response = await authApi.requestPasswordReset({ email });
      setServerMessage(response.message);
      notifySuccess('Permintaan terkirim', response.message, false);
    } catch (err) {
      setError('Permintaan reset password gagal diproses.');
      notifyError('Gagal meminta reset password', err, false);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl font-bold">Lupa password</CardTitle>
          <CardDescription>Masukkan email akun Anda. Jika terdaftar, kami akan mengirim link reset password.</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <Alert variant="destructive" className="items-center">
                <AlertCircle className="h-4 w-4" />
                <AlertDescription>{error}</AlertDescription>
              </Alert>
            )}
            {serverMessage && (
              <Alert className="items-center">
                <AlertDescription>{serverMessage}</AlertDescription>
              </Alert>
            )}
            <div className="space-y-2">
              <Label htmlFor="forgot-email">Email</Label>
              <Input
                id="forgot-email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="Masukkan email Anda"
                disabled={isSubmitting}
                required
              />
            </div>
            <Button type="submit" className="w-full" disabled={isSubmitting}>
              {isSubmitting ? 'Mengirim link...' : 'Kirim link reset'}
            </Button>
            <div className="text-center text-sm text-muted-foreground">
              <Link to="/login" className="underline underline-offset-4">
                Kembali ke login
              </Link>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
